import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminNivelesAutorizacionPage } from "@/features/admin-niveles-autorizacion/components/AdminNivelesAutorizacionPage";
import { nivelesAutorizacionQueryOptions } from "@/features/admin-niveles-autorizacion/hooks/use-niveles-autorizacion";
import { areasAdminQueryOptions } from "@/features/admin-areas/hooks/use-areas-admin";
import { rolesAdminQueryOptions } from "@/features/admin-roles/hooks/use-roles-admin";

/**
 * Ruta `/admin/flujos-autorizacion` · niveles agrupados por flujo. Precarga
 * áreas + niveles + roles (para los checkboxes de autorizadores) en paralelo.
 */
export const Route = createFileRoute("/_authed-tw/admin/flujos-autorizacion")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(nivelesAutorizacionQueryOptions),
      queryClient.ensureQueryData(areasAdminQueryOptions),
      queryClient.ensureQueryData(rolesAdminQueryOptions),
    ]),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminFlujosAutorizacion]}>
      <AdminNivelesAutorizacionPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
